import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "expandButton", "collapseButton"]

  expand() {
    this.toggle(false)
  }

  collapse() {
    this.toggle(true)
  }

  toggle(collapsed) {
    this.contentTargets.forEach((el) =>
      el.classList.toggle("hidden", collapsed),
    )
    this.expandButtonTarget.classList.toggle("hidden", !collapsed)
    this.collapseButtonTarget.classList.toggle("hidden", collapsed)
  }
}
